import * as types from './types';

const initialState = {
  showModal: false,
  component: null,
  title: '',
  width: '520px',
  closable: '',
  style: {},
  className: '',
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_MODAL: {
      const {
        title,
        component,
        width,
        top,
        closable,
        styles,
        className,
      } = action.payload;
      return {
        showModal: true,
        title,
        component,
        width,
        top,
        closable,
        style: styles,
        className,
      };
    }
    case types.HIDE_MODAL: {
      return initialState;
    }
    default:
      return state;
  }
};
export default modalReducer;
